import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { PatientService } from 'src/app/components/patient/service/patient.service';
import { messagelanguage } from 'src/environments/environment';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent implements OnInit {
  @Output() passwordChanged = new EventEmitter<void>();
  vc_resetPasswordForm: FormGroup;
  vc_passwordResetSuccess: boolean;

  constructor(
    private oc_fb: FormBuilder,
    private oc_patientService: PatientService,
    public oc_toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.vc_resetPasswordForm = this.oc_fb.group({
      iCurrentPassword: ['', [Validators.required]],
      iPassword: ['', [Validators.required]],
      iConfirmPassword: ['', [Validators.required]],
    });
  }

  async fn_resetPassword() {
    const self = this;
    let currentPassword = self.vc_resetPasswordForm.get('iCurrentPassword').value;
    let newPassword = self.vc_resetPasswordForm.get('iPassword').value;

    console.log(currentPassword);
    console.log(newPassword);

    (await this.oc_patientService
      .changePassword(currentPassword, newPassword))
      .subscribe((response: any) => {
        this.vc_passwordResetSuccess = true;
        this.oc_toastr.success(messagelanguage.message.Password_change_success);
        this.passwordChanged.emit();
      }, (error: any) => {
        if (error.status == 400 && error.error.message == "Password_update_wrong" ) {
          this.oc_toastr.error(messagelanguage.message.Password_update_wrong);
        } else if (error.status == 400 && error.error.message == "User_Not_Found" ) {
          this.oc_toastr.error(messagelanguage.message.User_Not_Found);
        } else if (error.status == 500 ) {
          this.oc_toastr.error(messagelanguage.message.No_control_error);
        }
      });
  }
}
